export const sortByLabel = (a, b) => a.label.localeCompare(b.label);

export const sortByOrder = (a, b) => a.order - b.order;

export const uniqueByField = (array, field) => {
  const seen = new Set();
  if (array.length) {
    return array.filter((opt) => {
      if (seen.has(opt[field])) return false;
      seen.add(opt[field]);
      return true;
    });
  }
  return [];
};
